import { FunctionComponent } from 'react';

interface LoaderProps {
    isLoading?: boolean;
    size?: 'xsmall' | 'small';
    style?: React.StyleHTMLAttributes<HTMLDivElement>
    inlineBlock?: boolean;
    cssModifiers?: string;
}

const Loader: FunctionComponent<LoaderProps> = ({ isLoading, size, inlineBlock = false, cssModifiers, style }: LoaderProps) => {
    const cssClasses = ['loader'];

    if (size) {
        cssClasses.push(`loader--${size}`);
    }
    if (inlineBlock) {
        cssClasses.push('loader--inline-block');
    }

    if (cssModifiers) {
        cssClasses.push(cssModifiers);
    }

    if (isLoading === false) {
        return null;
    }

    return (
        <div style={style} className={cssClasses.join(' ')} />
    );
};

export default Loader;